import { Component, Input, OnInit } from '@angular/core';
import { DisableVoucherEnum, Voucher } from '../../../utils/voucher';
import { MODAL, ModalService } from '../../modal.service';
import { PermissionService } from '@abp/ng.core';
import { GTM } from 'src/app/_services/gtm.service';
import { Router } from '@angular/router';
import { formatDateFr } from 'src/app/_helpers/common.helper';

@Component({
  selector: 'ng-casto-voucher',
  templateUrl: './voucher.component.html',
})
export class VoucherComponent implements OnInit {
  @Input() voucher: Voucher;
  now: Date;
  canDisableVoucher: boolean = false;

  constructor(
    private modalService: ModalService,
    private permissionService: PermissionService,
    private gtm: GTM,
    private router: Router
  ) { }

  ngOnInit() {
    this.now = new Date();
    this.now.setHours(0, 0, 0, 0);

    const canCancelVoucher = this.permissionService.getGrantedPolicy('Divers.CancelCoupon');
    const canBurnVoucher = this.permissionService.getGrantedPolicy('Divers.BurnCoupon');

    this.canDisableVoucher = canCancelVoucher || canBurnVoucher;
  }

  isExpire(dateEnd: Date): boolean {
    dateEnd = new Date(dateEnd);
    dateEnd.setHours(0, 0, 0, 0);
    return dateEnd.getTime() < this.now.getTime();
  }

  printVoucher() {
    const title = "Coupon de réduction de " + this.voucher.title;
    const currentUrl = this.router.url;
    let location = "Mon compte";
    if (currentUrl.includes('/clients/carte')) {
      location = 'Mes récompenses fidélités';
    }
    this.gtm.trackInteraction("coupon_codebarre", title, { "location": location });
    this.modalService.display(MODAL.DISPLAY_BARCODE, {
      barcodeValue: this.voucher.code,
      icon: 'assets/img/icons.svg#icon-discount',
      title: title,
      subtitle: this.getValidityLabel(),
    });
  }

  /**
   * Mention de validité affichée sous le titre du coupon, à l'écran comme à l'impression.
   */
  private getValidityLabel(): string {
    const dateEnd = formatDateFr(this.voucher?.dateEnd);
    return dateEnd ? `Valable jusqu'au ${dateEnd}` : '';
  }

  disableVoucher() {
    this.modalService.display(MODAL.DISABLE_VOUCHER, {
      title: 'Coupon de réduction de ' + this.voucher.title,
      voucher: this.voucher,
    });
  }
}
